import { useEffect } from "react";

interface ToastProps {
  message: string | null;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="pointer-events-none fixed bottom-8 left-1/2 z-[60] -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-2 rounded-lg bg-foreground-950/90 px-4 py-3 text-sm text-background-50">
        <i className="ri-checkbox-circle-line text-lg text-accent-400" />
        {message}
      </div>
    </div>
  );
}